import { useRouter } from 'next/router';
import IconBulb from './Svg/Bulb';
import styles from 'styles/modules/BoxTopTip.module.scss';
import Typo from './Typo';
import Button from 'components/Button';
import { useState } from 'react';
import ArrowDown from './Svg/ArrowDown';

const BoxTopTip = (props) => {
    const { data } = props;
    if (!data) return null;

    const [collapsed, setCollapse] = useState(false);

    const isCollapsable = data.allowCollapse ? true : false;

    const router = useRouter();

    const small = data.small ? (
        <small className={styles.small}>{data.small}</small>
    ) : null;

    const title = data.title ? (
        <h3
            className={styles.title}
            dangerouslySetInnerHTML={{ __html: data.title }}
        />
    ) : null;

    const priceSection = data.price_description ? (
        <p className={styles['price-wrapper']}>
            {data?.price && (
                <small className={styles['price-wrapper__price']}>
                    {data.price}
                </small>
            )}
            <small
                className={styles['price-wrapper__description']}
                dangerouslySetInnerHTML={{
                    __html: data.price_description,
                }}
            />
        </p>
    ) : null;

    const bodyImage = data.body_image ? <img src={data.body_image} /> : null;

    const body = data.body ? (
        <div
            className={styles.body}
            dangerouslySetInnerHTML={{ __html: data.body }}
        />
    ) : null;

    const person = data.person ? (
        <div className={styles['box-toptip__person']}>
            <img
                className={styles['box-toptip__person-image']}
                src={data.person.avatar}
            />
            <div className={styles['box-toptip__person-info']}>
                <Typo variant={'h4'}>{data.person.fullname}</Typo>
                <small>{data.person.position}</small>
            </div>
        </div>
    ) : null;

    const cta = data.cta ? (
        <Button
            theme={'primary'}
            title={data.cta.title}
            onClick={data.cta.onClick}
            loading={data.cta.loading}
        />
    ) : null;

    const toggleCollapse = () => {
        return collapsed === true ? setCollapse(false) : setCollapse(true);
    };

    return (
        <div
            className={[
                styles['box-toptip'],
                styles[`box-toptip--${data.theme}`],
                isCollapsable === true
                    ? styles['box-toptip--collapsable']
                    : null,
                collapsed === true
                    ? styles['box-toptip--collapsable-is-open']
                    : null,
            ].join(' ')}
        >
            {data.icon ? (
                <div className={styles['box-toptip__icon']}>
                    {data?.icon && data.icon.variant === 'small' ? (
                        <>
                            <div className={styles['box-toptip__icon-inside']}>
                                <IconBulb />
                            </div>
                            {small}
                        </>
                    ) : (
                        <>
                            <div
                                className={
                                    styles['box-toptip__icon-inside--big']
                                }
                            >
                                <img src={data.icon.src} />
                            </div>
                        </>
                    )}
                </div>
            ) : null}

            <div className={styles['box-toptip__body-wrapper']}>
                {isCollapsable && (
                    <div className={styles['box-toptip__small--mobile']}>
                        {small}
                    </div>
                )}

                <div
                    className={styles['box-toptip__headline']}
                    onClick={() => {
                        if (isCollapsable === true) {
                            toggleCollapse();
                        }
                    }}
                >
                    {title}
                    {isCollapsable && (
                        <a
                            href="#"
                            className={[
                                styles['box-toptip__collapse-button'],
                            ].join(' ')}
                        >
                            <ArrowDown />
                        </a>
                    )}
                </div>

                <div className={styles['box-toptip__body-wrap']}>
                    {bodyImage}
                    {body}

                    {person}
                    {cta}
                    {priceSection}
                </div>
            </div>
        </div>
    );
};

export default BoxTopTip;
